import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionStatus } from "../../../common/constants/action-status";
import { StoreState } from "../../../store/store.interface";
import { getUserProfileQuestions } from "../api/get-user-questions";
import { handleApiError, ApiError } from "../../../common/utils/api-utils";

export const fetchUserProfileQuestions = createAsyncThunk(
    'userProfile/fetchUserProfileQuestions',
    async (_data, thunkAPI) => {
      try {
        return await getUserProfileQuestions();
      } catch (error) {
        console.error(error);
        if (error instanceof ApiError) {
          handleApiError(error);
        }
        return thunkAPI.rejectWithValue(error);
      }
    },
    {
      condition: (_arg, { getState }) => {
        const state = getState() as StoreState;
        return state.userProfileState.securityQuestionResponse.status !== ActionStatus.loading;
      },
    }
  );
  